import './index.css';

import { Button, Dropdown, Layout, Menu } from 'antd';
import { FaHandshake, FaRegCreditCard, FaWallet } from 'react-icons/fa';
import { FiCopy, FiLink, FiLogOut } from 'react-icons/fi';
import { Recharge, Report, Withdraw } from '~/pages/Report';
import {
  RiHistoryFill,
  RiMenuFoldLine,
  RiMenuUnfoldLine,
  RiRefundLine,
  RiUserSettingsLine,
} from 'react-icons/ri';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { BsGift } from 'react-icons/bs';
import { Dashboard } from '~/pages/Home';
import { FaChartLine } from 'react-icons/fa';
import { FaMoneyBillTransfer } from 'react-icons/fa6';
import { FcMoneyTransfer } from 'react-icons/fc';
import { GiTakeMyMoney } from 'react-icons/gi';
import HistoryChangeWallet from '~/pages/HistoryChangeWallet';
import HistoryGiftCode from '~/pages/HistoryGiftCode';
import { IoIosArrowDown } from 'react-icons/io';
import { Links } from '~/data/dummy';
import { LuLayoutDashboard } from 'react-icons/lu';
import ModalChangeBank from '~/pages/Account/component/ModalChangeBank';
import ModalWithdraw from '../components/ModalWithdraw';
import { NS } from '~/utils/ns';
import { Refund } from '~/pages/Refund';
import SelectLanguage from './SelectLaguages';
import aesjs from 'aes-js';
import axios from 'axios';
import { baseUrl, clientUrl } from '~/utils/helper';
import { toast } from 'react-toastify';
import { useStateContext } from '~/contexts/ContextProvider';
import { useTranslation } from 'react-i18next';
import { instanceNoAuth } from '~/utils/axios';

// Import CSS file

const { Header, Content, Sider } = Layout;

const DefaultLayout = ({ children }) => {
  const { formatMoney } = useStateContext();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { t } = useTranslation([NS['profile']]);
  const { setRef, ref, agency, setAgency } = useStateContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenWithdraw, setIsOpenWithdraw] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [navLinks, setNavLinks] = useState([]);
  const navigate = useNavigate();
  let location = useLocation();
  const [scale, setScale] = useState(1);
  const [setting, setSetting] = useState({});
  const [logoError, setLogoError] = useState(false);
  const getSetting = async () => {
    try {
      const res = await instanceNoAuth().get('/setting');
      setSetting(res);
      setLogoError(false);
    } catch (error) {
      console.log(error);
      setLogoError(true);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);
        localStorage.setItem('device', 'mobile');
      } else if (window.innerWidth >= 1400) {
        setScale(1);
        setIsMobile(false);
        localStorage.setItem('device', 'desktop');
      } else {
        const newScale = window.innerWidth / 1400;
        setIsMobile(false);
        localStorage.setItem('device', 'desktop');
        setScale(newScale);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const links = [
    {
      label: 'Dashboard',
      key: '/',
      icon: <LuLayoutDashboard size={24} />,
      element: <Dashboard />,
    },
    {
      label: t('common:baocaodaily'),
      key: '/report',
      icon: <FaChartLine size={24} />,
      element: <Report />,
    },
    {
      label: t('common:lsnaptien'),
      key: '/recharge',
      icon: <FaRegCreditCard size={24} />,
      element: <Recharge />,
    },
    {
      label: t('common:lsruttien'),
      key: '/withdraw',
      icon: <FaMoneyBillTransfer size={24} />,
      element: <Withdraw />,
    },
    {
      label: t('common:lshoantra'),
      key: '/refund',
      icon: <RiRefundLine size={24} />,
      element: <Refund />,
    },
    {
      label: t('common:lsgiftcode'),
      key: '/history-giftcode',
      icon: <BsGift size={24} />,
      element: <HistoryGiftCode />,
    },
    // {
    //   label: t("common:lschinhvi"),
    //   key: "/history-change-wallet",
    //   icon: <FaWallet size={18} />,
    //   element: <HistoryChangeWallet />,
    // },
  ];

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    let token = query.get('token');
    if (token) {
      const key = [0, 1, 2, 5, 4, 5, 9, 7, 8, 9, 99, 11, 12, 0, 14, 65];
      const iv = [21, 22, 42, 24, 25, 56, 27, 29, 29, 88, 31, 95, 74, 67, 34, 36];
      const encryptedBytesDec = aesjs.utils.hex.toBytes(token);
      const aesCtrDec = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(iv));
      const decryptedBytes = aesCtrDec.decrypt(encryptedBytesDec);
      const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

      token = decryptedText;
      sessionStorage.setItem('auth', decryptedText);
    } else {
      token = sessionStorage.getItem('auth');
    }

    if (!token) {
      sessionStorage.removeItem('auth');
      window.location.href = '/account/login';
    } else {
      axios
        .get(`${baseUrl}/api/daily/check`, {
          headers: {
            'x-access-token': token,
            'Access-Control-Allow-Origin': '*',
          },
        })
        .then((res) => {
          let { status, data } = res.data.result;
          if (status) {
            setAgency(data);
            setRef(data.ref);

            const tempLinks = links.map((link) => {
              return {
                ...link,
                onClick: () => {
                  navigate(link.key);
                },
              };
            });
            setNavLinks(tempLinks);
          } else {
            window.location.href = '/account/login';
            sessionStorage.removeItem('auth');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('auth');
    window.location.href = '/account/login';
  };

  const handleCopyLink = () => {
    const referralLink = `${clientUrl}/register/${agency?.ref || ref || ''}`;
    navigator.clipboard.writeText(referralLink);
    toast.success(t('da_sao_chep_link_dang_ky'), {
      position: 'top-right',
      autoClose: 2000,
      theme: 'light',
    });
  };

  const handleCopyCode = () => {
    const refCode = agency?.ref || ref || '';
    navigator.clipboard.writeText(refCode);
    toast.success(t('da_sao_chep_ma_gioi_thieu'), {
      position: 'top-right',
      autoClose: 2000,
      theme: 'light',
    });
  };

  const items = [
    {
      key: '1',
      label: (
        <div onClick={() => navigate('/account/profile')} className="dropdown-item">
          <div className="dropdown-item-icon profile">
            <RiUserSettingsLine size={16} />
          </div>
          <span className="dropdown-item-text">{t('profile')}</span>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div
          onClick={() => {
            if (!agency?.bank_name) {
              toast.warning(t('vuilongthemnganhang'));
              setIsOpen(true);
            } else {
              setIsOpenWithdraw(true);
            }
          }}
          className="dropdown-item">
          <div className="dropdown-item-icon withdraw">
            <FcMoneyTransfer size={16} />
          </div>
          <span className="dropdown-item-text">{t('ruttien')}</span>
        </div>
      ),
    },
    {
      key: '3',
      label: (
        <div onClick={handleLogout} className="dropdown-item logout">
          <div className="dropdown-item-icon logout">
            <FiLogOut size={16} />
          </div>
          <span className="dropdown-item-text">{t('common:dangxuat')}</span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location.pathname]);

  const handleLogoError = () => {
    setLogoError(true);
  };

  const getLogoUrl = () => {
    if (!setting?.logo_image) return null;

    if (setting.logo_image.startsWith('http')) {
      return setting.logo_image;
    }

    if (baseUrl.endsWith('/') && setting.logo_image.startsWith('/')) {
      return baseUrl + setting.logo_image.substring(1);
    }

    if (!baseUrl.endsWith('/') && !setting.logo_image.startsWith('/')) {
      return baseUrl + '/' + setting.logo_image;
    }

    return baseUrl + setting.logo_image;
  };

  return (
    <Layout
      className={`default-layout ${isMobile ? 'mobile' : 'desktop'}`}
      style={{
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        height: `${100 / scale}dvh`,
      }}>
      <Sider
        breakpoint="xl"
        collapsedWidth={isMobile ? 1 : 70}
        collapsed={collapsed}
        className={`layout-sider ${isMobile && !collapsed ? 'mobile-open' : ''}`}>
        {/* Logo Section */}
        <div className={`logo-section ${collapsed ? 'collapsed' : ''}`}>
          {!collapsed ? (
            // <h2 className="logo-text">🤝 {t("dai_ly")}</h2>
            <img
              src={getLogoUrl()}
              alt="Logo"
              className="logo-image"
              onError={handleLogoError}
              style={{
                maxWidth: '100%',
                maxHeight: '60px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                display: 'block',
                margin: '0 auto',
              }}
            />
          ) : (
            <div
              className="logo-icon"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <FaHandshake size={28} className="text-white" />
            </div>
          )}
        </div>

        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[location.pathname]}
          items={navLinks}
          className={`custom-menu ${collapsed ? 'collapsed' : ''}`}
          inlineCollapsed={collapsed}
        />
      </Sider>

      <Layout
        className={`main-layout ${!collapsed ? '' : isMobile ? 'mobile-collapsed' : 'collapsed'}`}>
        <Header className={`layout-header ${isMobile ? 'mobile' : ''}`}>
          <ModalChangeBank isOpen={isOpen} setIsOpen={setIsOpen} />
          <ModalWithdraw isOpen={isOpenWithdraw} setIsOpen={setIsOpenWithdraw} />

          {/* Toggle Button */}
          <Button
            type="text"
            icon={
              collapsed ? (
                <RiMenuUnfoldLine size={isMobile ? 20 : 30} />
              ) : (
                <RiMenuFoldLine size={isMobile ? 20 : 30} />
              )
            }
            onClick={() => setCollapsed(!collapsed)}
            className={`toggle-button ${isMobile ? 'mobile' : ''}`}
          />

          {/* Referral Section */}
          {!(isMobile && !collapsed) && (
            <div className={`referral-section ${isMobile ? 'mobile' : 'gap-20'}`}>
              {/* Copy Registration Link */}
              <div
                onClick={handleCopyLink}
                className={`referral-link-btn ${isMobile ? 'mobile' : ''}`}>
                <FiLink size={16} />
                <span>{t('dang_ky')}</span>
              </div>

              {/* Copy Referral Code */}
              <div
                onClick={handleCopyCode}
                className={`referral-code-btn ${isMobile ? 'mobile' : ''}`}>
                <FiCopy size={isMobile ? 12 : 16} />
                <span className="referral-code-text">{agency?.ref || ref || 'Loading...'}</span>
              </div>
            </div>
          )}

          {/* User Section */}
          {!(isMobile && !collapsed) && (
            <div className={`user-section ${isMobile ? 'mobile' : ''}`}>
              {!isMobile && <SelectLanguage />}

              <Dropdown
                menu={{ items }}
                trigger={['click']}
                placement="bottomRight"
                overlayStyle={{
                  minWidth: '200px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
                }}>
                <div className={`user-dropdown ${isMobile ? 'mobile' : ''}`}>
                  <div className={`user-avatar ${isMobile ? 'mobile' : ''}`}>
                    {agency?.fullname?.charAt(0)?.toUpperCase()}
                  </div>
                  {!isMobile && (
                    <div className="user-info">
                      <span className="user-name">{agency?.fullname}</span>
                      <span className="user-money">{formatMoney(agency?.money)}</span>
                    </div>
                  )}
                  <IoIosArrowDown
                    size={isMobile ? 14 : 16}
                    className={`user-arrow ${isMobile ? 'mobile' : ''}`}
                  />
                </div>
              </Dropdown>
            </div>
          )}
        </Header>

        <Content
          className={`layout-content ${isMobile ? 'mobile' : ''} ${
            isMobile && !collapsed ? 'mobile-hidden' : ''
          }`}>
          <div className={`content-wrapper ${isMobile ? 'mobile' : ''}`}>{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DefaultLayout;
